import { EMPTY_LIST } from 'app/app.constants';
import { useMemo } from 'react';
import { Table } from 'altus-ui-components';
import { fromJS } from 'immutable';
import Badge from '@material-ui/core/Badge';

const ComparisionFileTableComponent = ({ logs }) => {
  const columns = useMemo(
    () => [
      {
        xs: 2,
        Header: 'Joint',
        accessor: (log) => log.get('joint'),
      },
      {
        xs: 2,
        Header: 'Start Log Depth',
        accessor: (log) => `${log.getIn(['startDepth', 'roundedValue'])} ${log.getIn(['startDepth', 'unit'])}`,
      },
      {
        xs: 2,
        Header: 'Class',
        accessor: (log) => {
          return (
            <>
              <Badge color="success" /> <>{log.get('class')}</>
            </>
          );
        },
      },
      {
        xs: 2,
        Header: 'Max Penetration',
        accessor: (log) => `${log.get('maxPenetration')?.toFixed(3)}%`,
      },
      {
        xs: 2,
        Header: 'Max ML Position',
        accessor: (log) => log.get('maxMLPosition')?.toFixed(3),
      },
      {
        xs: 2,
        Header: 'Direction',
        accessor: (log) => log.get('direction'),
      },
      {
        xs: 2,
        Header: 'Total Metal Loss',
        accessor: (log) => `${log.get('totalMetalLoss')}%`,
      },
    ],
    [],
  );
  return (
    <>
      <Table
        subrowOffset={3}
        items={fromJS(logs) ?? EMPTY_LIST}
        columns={columns}
        useGlobalFilter={false}
        noItemsMessage="No Log File has been selected yet."
      />
    </>
  );
};

export default ComparisionFileTableComponent;
